// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2h_jF","insightsList":"newBusinessInsightsMenu_insightsList__2Edav","active":"newBusinessInsightsMenu_active__3g4OP"};